import { useTranslation } from 'next-i18next';

import { FormSidebarItem } from '@/shared/components/layout/FormSidebar';
import { PersonalIdentifierType } from '@/shared/lib/sj-orm';

export const useAttributeGroups = () => {
  const { t } = useTranslation('entities/personalIdentifiers', { keyPrefix: 'groups' });

  const legalizedCopiesItem: FormSidebarItem = {
    title: t('legalizedCopies'),
    icon: 'file-minus',
    showActionButton: true,
  };

  const getGroups = (category: PersonalIdentifierType) => {
    const groups: FormSidebarItem[] = [
      { title: t('general'), icon: 'info' },
      { title: t('details'), icon: 'list-bullets' },
      ...(category !== PersonalIdentifierType.SUBSTANCE ? [legalizedCopiesItem] : []),
    ];

    return groups;
  };

  return { getGroups };
};
